import PubNub from "pubnub";

const PUBLISH_KEY = "pub-c-63a7232b-e72e-4d95-85be-c4fbe686bea5";
const SUBSCRIBE_KEY = "sub-c-c639ce69-ee49-462b-ba3c-fa32fc70f390";

let pubnubInstance = null;

export const initPubNub = (userName, authKey) => {
    pubnubInstance = new PubNub({
        publishKey: PUBLISH_KEY,
        subscribeKey: SUBSCRIBE_KEY,
        uuid: userName || "metagaim-user",
        authKey: authKey,
    });
    return pubnubInstance;
};

export const subscribeToMatch = (matchId, onMessage) => {
    if (!pubnubInstance) return;
    const channel = `MatchData-${matchId}`;
    pubnubInstance.addListener({
        message: (event) => {
            let msg = event.message;
            if (typeof msg === "string") {
                try {
                    msg = JSON.parse(msg);
                } catch(e) {
                    console.log("Parse error:", e);
                }
            }
            onMessage(msg);
        }
    });
    pubnubInstance.subscribe({ channels: [channel] });
};

export const unsubscribeFromMatch = (matchId) => {
    if (pubnubInstance) {
        pubnubInstance.unsubscribeAll();
        pubnubInstance.stop();
    }
};
